import { Button } from '@tovala/component-library'

import { openMessenger, showWebWidget } from 'utils/zendesk'
import { useUser } from 'contexts/user'
import ConfirmationDialog, {
  ConfirmationBody,
  ConfirmationButtons,
  ConfirmationHeader,
} from 'components/common/ConfirmationDialog'

const CommitmentBlockDialog = ({ onClose }: { onClose(): void }) => {
  const { user } = useUser()

  const commitmentWeeks =
    'commitmentWeeks' in user.commitmentDetails
      ? user.commitmentDetails.commitmentWeeks
      : 0
  const weeksRemaining =
    'weeksRemaining' in user.commitmentDetails
      ? user.commitmentDetails.weeksRemaining
      : 0
  const weeksOrdered = commitmentWeeks - weeksRemaining

  const handleContactSupport = () => {
    onClose()
    showWebWidget()
    openMessenger()
  }

  return (
    <ConfirmationDialog onRequestClose={onClose}>
      <ConfirmationHeader
        heading={
          <span>
            Oven promotion prevents
            <br />
            pausing or canceling
          </span>
        }
        onClickClose={onClose}
      />
      <ConfirmationBody>
        <div className="py-8 md:py-6">
          <p className="mx-auto max-w-sm text-body-sm">
            When you bought your Tovala Oven, you agreed to a promotional
            commitment to order {commitmentWeeks} separate meal deliveries
            within 6 months. You've fulfilled {weeksOrdered} out of{' '}
            {commitmentWeeks} meal deliveries. Once all {commitmentWeeks}{' '}
            deliveries are fulfilled, you'll be able to cancel your meal plan
            here. For now, skip any weeks you don't want meals or contact
            Customer Support to cancel your plan.
          </p>
        </div>
      </ConfirmationBody>
      <ConfirmationButtons>
        <div className="grid grid-cols-1 gap-3">
          <Button buttonStyle="dark" onClick={onClose} size="large">
            OK
          </Button>
          <Button
            buttonStyle="stroke"
            onClick={handleContactSupport}
            size="large"
          >
            Contact Customer Support
          </Button>
        </div>
      </ConfirmationButtons>
    </ConfirmationDialog>
  )
}

export default CommitmentBlockDialog
